import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Typography, Stack} from 'views/components';
import {AccessTime as AccessTimeIcon, CalendarToday as CalendarTodayIcon} from 'views/icons';
import {Translate} from 'views/module';

const moment = require('moment-timezone');

const TimeTile = (props) => {
  const {event} = props;

  const startDateTime = moment.tz(event.eventData.startTime, event.eventData.timezone);
  const endDateTime = moment.tz(event.eventData.endTime, event.eventData.timezone);

  const timezone = event.eventData.timezone;

  const formattedDate = startDateTime.format('dddd, MMMM D, YYYY');

  const startTime = startDateTime.format('h:mm A');
  const endTime = endDateTime.format('h:mm A');

  const duration = endDateTime.diff(startDateTime, 'hours');
  const timezoneAbbr = moment.tz(timezone).format('z');

  return (
    <Paper sx={{p: 2, mb: 2, borderRadius: 4}}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 2}}>
        <AccessTimeIcon sx={{width: 24, height: 24, color: '#b0b0b0'}}/>
        <Typography variant="h6">
          <Translate expression='schedule.eventDetail.TimeSection.Title' />
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <CalendarTodayIcon fontSize="small" />
        <Typography>
          {formattedDate}
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} mt={1}>
        <AccessTimeIcon fontSize="small" />
        <Typography>
          {startTime} - {endTime} {timezoneAbbr}
        </Typography>
        <Typography color="text.secondary" ml={2}>
          {duration} <Translate expression={duration === 1 ? 'schedule.eventDetail.TimeSection.hour' : 'schedule.eventDetail.TimeSection.hours'} />
        </Typography>
      </Stack>
    </Paper>
  );
};

TimeTile.propTypes = {
  event: PropTypes.object.isRequired,
};

export default TimeTile;
